const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectorswish = {
  button: '.button-wishlist',
  grid: '[grid-wishlist]',
  productCard: '.grid__item',
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.related-products')) initButtons();
  initGrid();
  updateWishlistCount();
});

// Custom Shopify Wishlist events
document.addEventListener('shopify-wishlist:updated', (event) => initGrid());
document.addEventListener('shopify-wishlist:init-product-grid', (event) => {});
document.addEventListener('shopify-wishlist:init-buttons', (event) => {});

// Fetch product card HTML
const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=wish`;
  return fetch(productTileTemplateUrl)
    .then(res => res.text())
    .then(text => {
      const parser = new DOMParser();
      const htmlDocument = parser.parseFromString(text, 'text/html');
      const productCard = htmlDocument.querySelector(selectorswish.productCard);
      return productCard ? productCard.outerHTML : '';
    })
    .catch(err => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

// Setup product grid
const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  grid.innerHTML = responses.join('');
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  document.dispatchEvent(new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist }
  }));
};

// Setup buttons and wishlist_text containers
const setupButtons = (buttons) => {
  buttons.forEach(button => {
    const productHandle = button.dataset.productHandle;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle`.');

    // Check if button is inside wishlist_text
    const container = button.closest('.wishlist_text') || button;

    // Set initial active state
    container.classList.toggle(BUTTON_ACTIVE_CLASS, wishlistContains(productHandle));

    // Click listener for both button and container
    container.addEventListener('click', () => {
      updateWishlist(productHandle);
      const nowActive = wishlistContains(productHandle);
      container.classList.toggle(BUTTON_ACTIVE_CLASS, nowActive);
      button.classList.toggle(BUTTON_ACTIVE_CLASS, nowActive);
      const notAdded = button.querySelector('.icon.not-added');
      const added = button.querySelector('.icon.added');
      if (notAdded) notAdded.style.display = nowActive ? 'none' : 'inline-block';
      if (added) added.style.display = nowActive ? 'inline-block' : 'none';
    });
  });
};

// Initialize grid
const initGrid = () => {
  const grid = document.querySelector(selectorswish.grid);
  if (grid) setupGrid(grid);
};

// Initialize buttons
const initButtons = () => {
  const buttons = Array.from(document.querySelectorAll(selectorswish.button));
  if (buttons.length) setupButtons(buttons);

  document.dispatchEvent(new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  }));
};

// Local Storage helpers
const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY);
  return wishlist ? wishlist.split(LOCAL_STORAGE_DELIMITER) : [];
};

const setWishlist = (array) => {
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, array.join(LOCAL_STORAGE_DELIMITER));
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  document.dispatchEvent(new CustomEvent('shopify-wishlist:updated', { detail: { wishlist: array } }));
  updateWishlistCount();
  return array;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const index = wishlist.indexOf(handle);
  if (index === -1) wishlist.push(handle);
  else wishlist.splice(index, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => getWishlist().includes(handle);
const resetWishlist = () => setWishlist([]);

// Update wishlist count in UI
const updateWishlistCount = () => {
  const wishlist = getWishlist();
  $('[data-js-wishlist-count]').attr('data-js-wishlist-count', wishlist.length).html(wishlist.length);

  if (wishlist.length === 0) {
    $(".wishlist-text").css("display", "block");
  } else {
    $(".wishlist-text").css("display", "none");
  }
};

// Initial call for jQuery-based elements
$(document).ready(function() {
  updateWishlistCount();
});
